/**
 * Decide whether an active (status=Y) peer-feedback skill should be disabled
 * during Settings save.
 *
 * - inForm: still present in the UI payload → keep
 * - !inForm && inOldExcels: loaded this session then removed → intentional disable
 * - !inForm && !inOldExcels: never shown in UI this session → leave alone
 */
export type ExcelSaveAction = 'keep-form' | 'disable' | 'keep-existing'

export function resolveActiveExcelSaveAction(args: {
  inForm: boolean
  inOldExcels: boolean
}): ExcelSaveAction {
  if (args.inForm) return 'keep-form'
  if (args.inOldExcels) return 'disable'
  return 'keep-existing'
}

export function shouldSkipExcelsCompanyWrite(args: {
  formExcelsCount: number
  oldExcelsCount: number
}): boolean {
  // Empty UI list while nothing was loaded = skills never fetched; do not write.
  return args.formExcelsCount === 0 && args.oldExcelsCount === 0
}
